import { capitalize } from '@mui/material'
import { C1Button, C1ButtonColorType, C1LoadingButton } from 'c1ui'
import { C1Dialog, C1DialogActions, C1DialogContent, C1DialogTitle } from 'components/core/dialog/C1Dialog'
import { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

export type ConfirmationDialogProps = {
    open: boolean
    actionLabel?: string
    cancelActionLabel?: string
    title: string
    details?: ReactNode
    onConfirm: () => void
    onCancel: () => void
    color?: C1ButtonColorType | 'warning'
    cancelColor?: C1ButtonColorType
    variant?: 'text' | 'outlined' | 'contained'
    isActionLoading?: boolean
}

/**
 * @deprecated This component doesn't really work with useSimpleModal, which is the preferred way to create modals.
 * Try using SimpleConfirmationDialog instead.
 */
const ConfirmationDialog = ({
    open,
    actionLabel,
    cancelActionLabel,
    title,
    onConfirm,
    onCancel,
    details,
    color = 'primary',
    variant = 'contained',
    isActionLoading = false,
}: ConfirmationDialogProps): React.ReactElement => {
    const onCloseHandler = (confirm: boolean): void => {
        if (confirm) {
            onConfirm()
        } else {
            onCancel()
        }
    }

    return (
        <C1Dialog open={open} onClose={(): void => onCloseHandler(false)} maxWidth="xs" color={color}>
            <C1DialogTitle>
                {title}
            </C1DialogTitle>
            <C1DialogContent>{details}</C1DialogContent>
            <C1DialogActions>
                <C1Button onClick={(): void => onCloseHandler(false)} variant="outlined">
                    {cancelActionLabel || (
                        <FormattedMessage id="component_delete_confirmation_cancel" defaultMessage="Go back" />
                    )}
                </C1Button>
                {actionLabel && (
                    <C1LoadingButton
                        onClick={(): void => onCloseHandler(true)}
                        variant={variant}
                        loading={isActionLoading}
                    >
                        {capitalize(actionLabel)}
                    </C1LoadingButton>
                )}
            </C1DialogActions>
        </C1Dialog>
    )
}
export default ConfirmationDialog
